import { Card, CardContent, Skeleton } from '@parrot-software/design-system';

interface PaymentHistoryMobileListSkeletonProps {
  cards?: number;
}

/**
 * PaymentHistoryMobileListSkeleton - Loading placeholder for the stacked-card
 * payment history view on narrow viewports.
 *
 * Mirrors the PaymentHistoryMobileList card structure: a date + subscription
 * column, the amount on the right, and a status badge below.
 */
export const PaymentHistoryMobileListSkeleton = ({ cards = 3 }: PaymentHistoryMobileListSkeletonProps) => {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: cards }).map((_, index) => (
        <Card key={`payment-history-mobile-skeleton-${index}`}>
          <CardContent className="flex flex-col gap-3 p-4">
            <div className="flex items-start justify-between gap-2">
              <div className="flex flex-col gap-1 min-w-0">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-32" />
              </div>
              <Skeleton className="h-4 w-20 shrink-0" />
            </div>
            <Skeleton className="h-5 w-24" />
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
